import { erpAxios } from '..';

const getTipoviDokumenata = async () => {
  const { data } = await erpAxios(`/dokumenti/tipovi`);
  return data;
};

export default getTipoviDokumenata;
